<template>
		<!--
			Main leagues 1,2,3
		-->
		<div class="col main-leagues" v-if="subsection">
			<div class="row gsap-fade-up">
				<div class="col">
					<div class="component__fullscreen-bg" :style="{'background-image': 'url('+normal(team.image)+')'}"></div>
				</div>
			</div>
			<div class="row section__white-bg">
				<div class="col">
					<div class="row">
						<div class="col">
							<p class="teams__league-season"></p>
							<p class="teams__league-name">L’équipe</p>
						</div>
					</div>

					<div
						v-if="team.iframe_link"
						class="row view-calendar"
						:class="{'player-info-open-mobile': $root.playerInfoOpen}">
						<div class="col">
							<button class="view-calendar__btn" @click="scrollToCalendar">CALENDRIER / CLASSEMENT</button>
						</div>
					</div>

					<div class="row relative">

						<transition name="fade">
							<div class="player" v-if="$root.playerInfoOpen">
								<div class="player__inner">
									
									<div class="player__close" @click="$root.playerInfoOpen = false">
										<p>fermer</p>
										<img src="/images/close-red.svg" alt="">
									</div>
									<div class="player__image player-animate" v-if="playerInfoView.image" :style="{backgroundImage: 'url('+medium(playerInfoView.image)+')'}"></div>
									<div class="player__body player-animate">
										<p class="player__position">{{playerInfoView.position.name}}</p>
										<h1 class="player__name">{{playerInfoView.name}}</h1>
										<p class="player__age" v-if="playerInfoView.age"><span>{{playerInfoView.age}}</span> ans</p>
										<p class="player__quote">
											« <span>{{playerInfoView.quote}}</span> »
										</p>
										<div class="player__stats" v-html="playerInfoView.description"></div>
									</div>
									<div class="player__nav player-animate">
										<div class="player__nav-prev" @click="previousPlayer">
											<img src="/images/arrow-left-white.svg" alt="">
											<p>Précédent</p>
										</div>
										<div class="player__nav-next" @click="nextPlayer">
											<p>Suivant</p>
											<img src="/images/arrow-left-white.svg" alt="">
										</div>
									</div>
							
								</div>
							</div>
						</transition>
						
						<div class="col-lg-7 col-xl-8 main-leagues__players-block" :class="{'player-info-open': $root.playerInfoOpen}" v-if="team.active_members && team.slug == '1ere-equipe'">
							<div class="row">
								<div class="col">
									<div class="row">
										<div 
											class="col-lg-12 col-xl-6 players-list" 
											:class="{'hide': leaguePlayersShow}" 
											v-if="player.type == 'Player'"
											v-for="(player, index) in team.active_members"
											:key="index">
											<div class="teams__league-player" @click="playerInfo(player, index)">
												<div class="image" v-if="player.image" :style="{backgroundImage: 'url('+thumbnail(player.image)+')'}"></div>
												<div class="info">
													<p class="position">{{player.position.name}}</p>
													<p class="name">{{player.name}}</p>
													<p class="age" v-if="player.age">{{player.age}} ans</p>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div
											v-if="team.active_members && team.slug == '1ere-equipe'"
											class="col d-lg-none"
											:class="{'player-info-open-mobile': $root.playerInfoOpen}">
											<button class="view-calendar__btn" @click="showAllPlayers">VOIR TOUS LES JOUEURS</button>
										</div>
									</div>
								</div>
							</div>


							<div class="row" v-if="staffMembers.length">
								<div class="col">
									<div class="row">
										<div class="col">
											<p class="teams__league-name">STAFF</p>
										</div>
									</div>

									<div class="row">
										<div
											class="col-lg-12 col-xl-6 players-list"
											:class="{'hide': leaguePlayersShow}"
											v-if="player.type == 'Staff'"
											v-for="(player, index) in team.active_members"
											:key="index">
											<div class="teams__league-player teams__league-staff">
												<div class="image" v-if="player.image" :style="{backgroundImage: 'url('+thumbnail(player.image)+')'}"></div>
												<div class="info">
													<p class="position">{{player.position.name}}</p>
													<p class="name">{{player.name}}</p>
													<p class="age" v-if="player.age">{{player.age}} ans</p>
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>

						</div>

						<div
							class="col-lg-7 col-xl-8 main-leagues__players-block simple-players"
							:class="{'player-info-open': $root.playerInfoOpen}"
							v-else-if="team.slug !== '1ere-equipe'">
							<div v-html="team.content"></div>

							<div class="row" v-if="staffMembers.length">
								<div class="col">
									<p class="teams__league-name">STAFF</p>
								</div>
							</div>

							<div class="row">
								<div
									class="col-lg-12 col-xl-6 players-list"
									:class="{'hide': leaguePlayersShow}"
									v-for="(player, index) in team.active_members"
									:key="index"
									v-if="player.type == 'Staff'">
									<div class="teams__league-player teams__league-staff">
										<div class="image" v-if="player.image" :style="{backgroundImage: 'url('+thumbnail(player.image)+')'}"></div>
										<div class="info">
											<p class="position">{{player.position.name}}</p>
											<p class="name">{{player.name}}</p>
											<p class="age" v-if="player.age">{{player.age}} ans</p>
										</div>
									</div>
								</div>
							</div>

						</div>
						
						<div class="col-lg-5 col-xl-4" :class="{'player-info-open-mobile': $root.playerInfoOpen}" v-if="team.iframe_link">
							<div class="row">
								<div class="col">
									<div class="league-iframe-block">
										<iframe
											class="league-iframe"
											frameborder="0"
											:src="team.iframe_link"></iframe>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>

			</div>
		</div>
</template>

<script>
	import _find from 'lodash/find'
	import { mapState } from 'vuex'

	export default {
		data() {
			return {
				team: {},
				section: {},
				subsection: {},
				leaguePlayersShow: true,
				playerInfoView: {}
			}
		},
		mounted() {
			this.fetchData()
		},
		watch: {
			'$route': function() {
				this.fetchData();
			},
			'$root.playerInfoOpen': function (val) {
				if (val) {
					if (window.innerWidth < 992) {
						$('body').addClass('no-overflow')
					}
					this.$root.playerInfoOpen = true;
				} else {
					$('body').removeClass('no-overflow')
					this.$root.playerInfoOpen = false;
				}
			},
			playerInfoView: function(val) {
				$('.player').scrollTop(0);
				TweenMax.staggerFromTo('.player-animate', .3, {opacity: 0}, {opacity: 1}, 0.1)
				if (val) {
					if (window.innerWidth > 992) {
						$('html, body').animate({
							scrollTop: ($('.teams__league-season').offset().top - 80)
						},300);
					}
				}
			}
		},
		methods: {
			fetchData() {
				let section = _find(this.sections, {slug: this.$route.params.sectionSlug})
				let subsection = _find(this.teamsWithCategories, {slug: this.$route.params.subsectionSlug})

				let team = _find(this.teams, {slug: this.$route.params.pageSlug})
				if (team.active_members.length > 0) {
					team.active_members.map((player, index) => {
						player.player_index = index;
					})
				}

				this.section = section
				this.subsection = subsection
				this.team = team


				let iframeIntervalHome = setInterval(() => {
					checkHeight()
				}, 1000)

				function checkHeight() {
					var myFrames = null;
					myFrames = document.querySelector('.league-iframe');
					if (myFrames && myFrames.clientHeight > 300) {
						clearInterval(iframeIntervalHome)
					}

					if (myFrames && myFrames.className.indexOf('league-iframe') >= 0) {
						myFrames.contentWindow.postMessage('getHeight;' + myFrames.src, myFrames.src);
					}

					window.addEventListener('message', function(e) {
						if (!myFrames) {
							return;
						}
						var sourceFrame = null;
						if (e.data.toString().indexOf(myFrames.src) > 0) {
							sourceFrame = myFrames;
						}

						if (sourceFrame != null)
						{
							sourceFrame.style.height = e.data.toString().split(';')[0] + 'px';
						}
					}, false);
				}

			},
			scrollToCalendar() {
				$('html, body').animate({
				    scrollTop: ($('iframe').offset().top)
				},500);
			},
			showAllPlayers() {
				this.leaguePlayersShow = !this.leaguePlayersShow
			},
			playerInfo(player) {
				this.playerInfoView = player;
				this.$root.playerInfoOpen = !this.$root.playerInfoOpen;
			},
			previousPlayer() {
				this.$nextTick(() => {
					if (this.playerInfoView.player_index == 0) {
						this.playerInfoView = this.team.active_members[this.team.active_members.length - 1];
					} else {
						this.playerInfoView = this.team.active_members[this.playerInfoView.player_index - 1];
					}
				})
			},
			nextPlayer() {
				this.$nextTick(() => {
					if (this.playerInfoView.player_index == this.team.active_members.length - 1) {
						this.playerInfoView = this.team.active_members[0];
					} else {
						this.playerInfoView = this.team.active_members[this.playerInfoView.player_index + 1];
					}
				})
			}

		},
		computed: {
			...mapState({
				sections: 'allSections',
				teams: 'teams',
				teamsWithCategories: 'teamsWithCategories'
			}),
			staffMembers() {
				if (this.team.active_members) {
					return this.team.active_members.filter( member => member.type == 'Staff')	
				} else {
					return []
				}
			}
		}
	}
</script>